export default __webpack_public_path__ + "static/media/ic-regions.7abcf55c.svg";